// Components
const SocialClubCreatePost = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "social-club-create-post" */ "@/app/views/main-view/social-club/components/social-club-create-post/social-club-create-post.vue"
	)
const SocialClubFeeds = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "social-club-feeds"*/ "@/app/views/main-view/social-club/components/social-club-feeds/social-club-feeds.vue"
	)
const SocialClubAdmin = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "social-club-admin"*/ "@/app/views/main-view/social-club/components/social-club-admin/social-club-admin.vue"
	)
const SocialClubAdminManagement = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "social-club-admin-management"*/ "@/app/views/main-view/social-club/components/social-club-admin-management/social-club-admin-management.vue"
	)
const ModalSocialReportContent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-report-content"*/ "@/app/views/main-view/social-club/components/modals/modal-social-report-content/modal-social-report-content.vue"
	)
const ModalSocialCreateGroup = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-create-group"*/ "@/app/views/main-view/social-club/components/modals/modal-social-create-group/modal-social-create-group.vue"
	)
const ModalMyGroupSearch = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-my-group-search"*/ "@/app/views/main-view/social-club/components/modals/modal-my-groups-search/modal-my-groups-search.vue"
	)
const ModalSocialTransferPrimaryAdmin = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-transfer-primary-admin"*/ "@/app/views/main-view/social-club/components/modals/modal-social-transfer-primary-admin/modal-social-transfer-primary-admin.vue"
	)

// Services
import PostService from "@/app/services/main/post/post-service"
import ClubsService from "@/app/services/main/club/club-service"

// Constants
import {
	STATUS_CODES,
	USER_CLUB_ACCESS,
	MEMBER_CLUB_GROUP_STATUS,
	USER_CLUB_STATUS,
} from "@/app/constants/status-constants"

// Mixins
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"

const defaultPaginateOption = {
	limit: 5,
	offset: 0,
}

export default {
	name: "SocialClubContainer",
	components: {
		SocialClubCreatePost,
		SocialClubFeeds,
		SocialClubAdmin,
		SocialClubAdminManagement,
		ModalSocialReportContent,
		ModalSocialCreateGroup,
		ModalMyGroupSearch,
		ModalSocialTransferPrimaryAdmin,
	},
	mixins: [userMixins, switchPetMixins],
	data() {
		return {
			tabs: [
				{
					id: "general",
					label: "Feeds",
					active: true,
				},
				{
					id: "reports",
					label: "Reports",
					active: false,
				},
				{
					id: "adminManagement",
					label: "Members",
					active: false,
				},
			],
			isAPILoading: false,
			feeds: [],
			options: { ...defaultPaginateOption },
			infiniteId: +new Date(),
			isAdminTab: false,
			reportContent: null,
			showGroupsDropdown: false,
			isGroupsLoading: false,
			groupList: [],
			isPendingRequestAdmin: false,
		}
	},
	watch: {
		getActiveGroup(group) {
			if (group) {
				this.setActiveGroup()
			}
		},
		socialClubFlags(newVal) {
			this.$store.commit("setHasUnsavedChanges", newVal)
		},
		getTempActiveGroup(newVal) {
			if (newVal && newVal.id !== this.getActiveGroup.id) {
				if (this.socialClubFlags) {
					this.$swal({
						imageHeight: "30px",
						title: "You have unsaved changes!",
						text: `Are you sure you want to leave ${this.getActiveGroup.name}?`,
						imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
						showCancelButton: true,
						confirmButtonColor: "#4B8BFF",
						cancelButtonColor: "#d33",
						confirmButtonText: "Proceed",
						reverseButtons: true,
					}).then((result) => {
						if (result.value) {
							this.$store.commit("resetFlags")
							this.$store.commit("setHasUnsavedChanges", false)
							this.$store.commit("setActiveGroup", newVal)
						}
					})
				} else {
					this.$store.commit("setActiveGroup", newVal)
				}
			}
		},
	},
	computed: {
		socialClubFlags() {
			const flags = Object.values(this.$store.getters.getSocialClubState)
			let hasChange = false

			for (let flag of flags) {
				if (flag) {
					hasChange = true
					break
				}
			}

			return hasChange
		},
		getActiveTab() {
			return this.tabs.find((tab) => tab.active)
		},
		isUserRoleAdmin() {
			return this.$store.getters.getIsClubAdmin
		},
		isUserRoleClubCreator() {
			return this.$store.getters.getClubCreator
		},
		getActivePetBreedId() {
			return this.$store.getters.getActivePet.breed.id
		},
		getActiveGroup() {
			return this.$store.getters.getActiveGroup
		},
		groupAdminRequests() {
			return this.$store.getters.getGroupAdminRequests
		},
		getTempActiveGroup() {
			return this.$store.getters.getTempActiveGroup
		},
	},
	mounted() {
		this.$store.dispatch("setGroupAdminRequest")
		window.addEventListener("scroll", this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener("scroll", this.scrollToTop)
	},
	methods: {
		scrollToTop() {
			// Get the button
			let btnToTop = document.getElementById("btn-back-to-top")
			if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
				btnToTop.style.display = "flex"
			} else {
				btnToTop.style.display = "none"
			}
		},
		backToTop() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		refreshActivePetData() {
			this.setActiveTab("general")
			this.resetActiveGroup()

			// Fetch all the groups inside the club
			this.getGroupList()
		},
		refreshFeed() {
			this.feeds = []
			this.options = { ...defaultPaginateOption }
			this.infiniteId += 1
		},
		async infiniteHandler($state) {
			// if group is selected, get club group first

			try {
				const {
					data: { posts },
				} = await PostService.getPosts({
					topic: this.getActiveTab.id,
					groupId: this.getActiveGroup.id,
					offset: this.options.offset,
					limit: this.options.limit,
				})

				if (posts.length) {
					this.feeds = this.feeds.concat(posts)
					this.options.offset = this.options.offset + this.options.limit

					$state.loaded()
					if (posts.length < this.options.limit) {
						$state.complete()
					}
				} else {
					$state.complete()
				}
			} catch (error) {
				$state.error()
			}
		},
		newPostCallback(post) {
			post.newPost = true

			this.feeds = [post].concat(this.feeds)
		},
		updatePostCallback(updatedPost) {
			this.feeds = this.feeds.map((post) => {
				if (updatedPost.id === post.id) {
					return updatedPost
				}

				return post
			})
		},
		async deletePostCallback(postId) {
			const res = await PostService.deletePost(postId)

			if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
				this.feeds = this.feeds.filter(({ id }) => id !== postId)
				this.showCustomSuccessToast("Post has been deleted.")
			} else {
				const { ERROR_DELETE_POST } = this.toastMessages.post()
				this.showAPIErrorToast(ERROR_DELETE_POST, res)
			}
		},
		setActiveTab(selectedTab) {
			this.tabs = this.tabs.map((tab) => {
				// set the selected tab to active
				tab.active = tab.id === selectedTab
				// this is to show the admin component
				this.isAdminTab = selectedTab === "admin"

				return tab
			})

			this.$store.commit("resetFlags")
			this.refreshFeed()
		},
		leaveClub() {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
				imageAlt: "Sad Dog",
				titleText: `Leave ${this.getActiveGroup.name} Group`,
				html: `<p>Are you sure you want to leave the ${this.getActiveGroup.name} Group? <br>You may join back anytime.</p>`,
				confirmButtonText: "Confirm",
				cancelButtonText: "Cancel",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					const requestBody = {
						customerIds: [this.$store.getters.getUserDetails.id],
						status: USER_CLUB_STATUS.INACTIVE,
					}

					ClubsService.updateGroupMemberStatus(this.getActiveGroup.id, requestBody).then(() => {
						this.showCustomSuccessToast(`You have left the ${this.getActiveGroup.name} group.`)
						this.resetActiveGroup()
					})
				}
			})
		},
		requestOrResignToBeAdmin() {
			let imageUrl, imageAlt, titleText, html, confirmButtonText

			const requestBody = {
				customerId: this.$store.getters.getUserDetails.id,
				access: this.isUserRoleAdmin ? USER_CLUB_ACCESS.MEMBER : USER_CLUB_ACCESS.PENDING,
			}
			if (this.isPendingRequestAdmin) {
				this.$swal({
					imageHeight: "30px",
					imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
					imageAlt: "Success Dog",
					titleText: `Pending Request to be an admin`,
					html: `<p>Your request to be an Admin in <strong>${this.getActiveGroup.name} Group</strong> is still pending.<br>Please wait for the <strong>Group Admin</strong> to approve your request.</p>`,
					showConfirmButton: false,
					cancelButtonText: "Got it",
					customClass: {
						header: "header-social-club",
						title: "title-social-club",
					},
					showCancelButton: true,
					reverseButtons: true,
				})
			} else {
				if (this.isUserRoleAdmin) {
					imageUrl = `${require("@/assets/images/_shared/sad-dog.png")}`
					imageAlt = "Sad Dog"
					titleText = `Resign as an Admin - ${this.getActiveGroup.name} Group`
					html = `<p>Are you sure you want to resign as an admin of the ${this.getActiveGroup.name} Group? You will no longer be able to action reported contents of other members.</p>`
					confirmButtonText = `Confirm`
				} else {
					imageUrl = `${require("@/assets/images/_shared/dog-confirm.png")}`
					imageAlt = "Confirm Dog"
					titleText = `Request to be an Admin - ${this.getActiveGroup.name} Group`
					html = `<p>Are you sure you want to request to be an admin of the ${this.getActiveGroup.name} Group? You will be able to decide on reported contents of other members.</p>`
					confirmButtonText = `Send Request`
				}

				this.$swal({
					imageHeight: "30px",
					imageUrl,
					imageAlt,
					titleText,
					html,
					confirmButtonText,
					cancelButtonText: "Cancel",
					customClass: {
						header: "header-social-club",
						title: "title-social-club",
					},
					showCancelButton: true,
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						this.updateMemberAccess(requestBody)
					}
				})
			}
		},
		updateMemberAccess(requestBody) {
			ClubsService.updateGroupMemberAccess(this.getActiveGroup.id, requestBody)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						if (this.isUserRoleAdmin) {
							this.showCustomSuccessToast("Successfully resigned as admin.")
							this.$store.commit("toggleIsClubAdmin", false)
							this.setActiveTab("general")
						} else {
							this.showCustomSuccessToast("Request to be an admin has been sent.")
							this.isPendingRequestAdmin = true
						}
					} else {
						this.showAPIErrorToast(res)
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
		},
		showReportContentModal(content) {
			this.reportContent = { ...content, type: "POST" }
			this.$refs.socialReportContentModal.openModal()
		},
		showCreateGroupModal() {
			this.$refs.createGroupModal.openModal()
		},
		showMyGroupSearchModal() {
			this.$refs.myGroupSearchModal.openModal()
		},
		showTransferPrimaryAdmin() {
			this.$refs.transferPrimaryAdmin.openModal()
		},
		transferPrimaryAdmin(customerId) {
			const requestBody = {
				customerId: customerId,
				access: USER_CLUB_ACCESS.CREATOR,
			}

			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
				imageAlt: "Sad Dog",
				titleText: `Transfer Primary Admin`,
				html: `<p>Are you sure you want to transfer primary admin access?</p>`,
				confirmButtonText: "Confirm",
				cancelButtonText: "Cancel",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					ClubsService.updateGroupMemberAccess(this.getActiveGroup.id, requestBody)
						.then(async (res) => {
							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast("Successfully transfer Primary Admin.")
								this.$store.commit("toggleIsClubAdmin", false)
								this.$store.commit("setClubCreator", false)
								this.setActiveTab("general")
								this.$refs.transferPrimaryAdmin.closeModal()
								await this.$store.dispatch("setGroupAdminRequest")
							} else {
								this.showAPIErrorToast(res)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
				}
			})
		},
		requestToJoinInGroup(data) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
				imageAlt: "Success Dog",
				titleText: `Request To Join In - ${data.name} Group`,
				html: `<p>Are you sure you want to request to be part of the ${data.name} Group? <br>You will be able to see all the posts and comments inside the group.</p>`,
				confirmButtonText: "Send Request",
				cancelButtonText: "Cancel",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// Call request to join in group API endpoint
					ClubsService.requestToJoinInGroup(data.id).then(() => {
						this.showCustomSuccessToast(`Request to join ${data.name} group has been sent.`)
					})
				}

				// Clear selected group to go back to social
				this.resetActiveGroup()
			})
		},
		pendingRequestToJoinInGroup(groupName) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
				imageAlt: "Success Dog",
				titleText: `Pending Request`,
				html: `<p>Your request to join in <strong>${groupName} Group</strong> is still pending.<br>Please wait for the <strong>Group Admin</strong> to approve your request.</p>`,
				showConfirmButton: false,
				cancelButtonText: "Got it",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				// Clear selected group to go back to social
				this.resetActiveGroup()
			})
		},
		showAddMembersModal() {
			this.$refs.addMembersModal.openModal()
		},
		showMemberRequestModal() {
			this.$refs.memberRequestModal.openModal()
		},
		setActiveGroup() {
			if (this.getActiveGroup.id === 1001) {
				this.$router.push("/social")
				this.$store.commit("toggleIsClubAdmin", false)
				this.$store.commit("setClubCreator", false)
			} else {
				// Check if user is member of the club group
				if (this.getActiveGroup.memberStatus === MEMBER_CLUB_GROUP_STATUS.ACTIVE) {
					// redirect to club group page
					this.$router.push("/social/group")

					// check customer is admin or creator
					if (
						this.getActiveGroup.access === USER_CLUB_ACCESS.ADMIN ||
						this.getActiveGroup.access === USER_CLUB_ACCESS.CREATOR
					) {
						this.$store.commit("toggleIsClubAdmin", true)
						if (this.getActiveGroup.access === USER_CLUB_ACCESS.CREATOR) {
							this.$store.commit("setClubCreator", true)
						} else {
							this.$store.commit("setClubCreator", false)
						}
					} else {
						this.isPendingRequestAdmin =
							this.getActiveGroup.access === USER_CLUB_ACCESS.PENDING ? true : false

						this.$store.commit("toggleIsClubAdmin", false)
						this.$store.commit("setClubCreator", false)
					}
				} else if (this.getActiveGroup.memberStatus === MEMBER_CLUB_GROUP_STATUS.PENDING) {
					// Show pending request modal
					this.pendingRequestToJoinInGroup(this.getActiveGroup.name)
				} else {
					// Show request to join in club group modal
					this.requestToJoinInGroup(this.getActiveGroup)
				}
			}

			this.setActiveTab("general")
			this.refreshFeed()
		},
		resetActiveGroup() {
			this.$store.commit("resetActiveGroup")
		},
		toggleGroupsDropdown() {
			this.showGroupsDropdown = !this.showGroupsDropdown
		},
		refreshGroupList() {
			this.getGroupList()

			setTimeout(() => {
				this.$refs.addMembersModal.openModal()
			}, 500)
		},
		checkPendingCount(tab) {
			let show = false

			if (this.groupAdminRequests && this.groupAdminRequests.pendingReports) {
				if (tab.id === this.tabs[1].id) {
					// get reported pending count for the active group
					const findGroupPendingReports = this.groupAdminRequests.pendingReports.find(
						(pendingReport) => pendingReport.groupId == this.getActiveGroup.id
					)

					show =
						findGroupPendingReports && findGroupPendingReports.pendingReportsCount > 0 && !tab.active
							? true
							: false
				} else if (tab.id === this.tabs[2].id) {
					// get rmember request and admin request count for the active group
					const findAdminRequest = this.groupAdminRequests.adminRequests.find(
						(adminRequest) => adminRequest.groupId == this.getActiveGroup.id && adminRequest.access === "CC"
					)
					const findMemberRequest = this.groupAdminRequests.memberRequests.find(
						(memberRequest) => memberRequest.groupId == this.getActiveGroup.id
					)

					show =
						((findAdminRequest && findAdminRequest.adminRequestCount > 0) ||
							(findMemberRequest && findMemberRequest.memberRequestCount > 0)) &&
						!tab.active
							? true
							: false
				}
			}

			return show
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.socialClubFlags && to.path !== "/login") {
			this.$swal({
				imageHeight: "30px",
				title: "You have unsaved changes!",
				text: "Are you sure you want to leave this page?",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				showCancelButton: true,
				confirmButtonColor: "#4B8BFF",
				cancelButtonColor: "#d33",
				confirmButtonText: "Proceed",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.$store.commit("resetFlags")
					next(true)
				} else {
					next(false)
				}
			})
		} else {
			next()
		}
	},
}
